import React, { useState } from "react";
import { Plus, Package } from "lucide-react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
// import UnitList from "./UnitList/UnitList";
// import UnitModal from "./UnitModal/UnitModal";
import "./UnitsPage.scss";
import { fetchUnitsList } from "../../Services/FetchUnitsList";
import DataGridWithActions from "../../Components/DataGridWithActions";
import UnitModal from "./UnitModal";
import { createUnit, deleteUnit, updateUnit } from "./UnitService";
import { AddAnElementButton } from "../../Components/AddElementsButton";
import {
  deleteAlert,
  errorAlert,
  handleSuccess,
  infoAlert,
  updateAlert,
} from "../../Components/Alerts";
import CrudPageHeader from "../../Components/CrudPageHeader";

export default function UnitsPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingUnit, setEditingUnit] = useState(null);
  // const [searchQuery, setSearchQuery] = useState("");

  const queryClient = useQueryClient();

  // ------------------ React Query: Fetch Units (object form v5) ------------------
  const { data: units = [], isLoading } = useQuery({
    queryKey: ["units"],
    queryFn: fetchUnitsList,
    staleTime: 1000 * 60, // 1 minut caching
    onError: () => errorAlert("Njësitë matëse nuk mund të shfaqen"),
  });

  // ------------------ Mutation (object form v5) ------------------
  // UnitsPage.js - React Query Mutation
  const mutation = useMutation({
    mutationFn: ({ type, id, payload }) => {
      if (type === "create") return createUnit(payload);
      if (type === "update") return updateUnit(payload);
      if (type === "delete") return deleteUnit(id);
    },
    onSuccess: (message, variables) => {
      if (variables.type === "create")
        handleSuccess("Njësia u krijua me sukses!");
      if (variables.type === "update")
        updateAlert("Njësia u përditësua me sukses!");
      if (variables.type === "delete") deleteAlert(message);
      queryClient.invalidateQueries({ queryKey: ["units"] });
      setIsModalOpen(false);
    },
    onError: (error, variables) => {
      let action =
        variables.type === "create"
          ? "krijimi"
          : variables.type === "update"
            ? "përditësimi"
            : "fshirja";
      errorAlert(`Dështoi ${action}: ${error.message}`);
    },
  });

  // ------------------ Handlers ------------------
  const handleAddClick = () => {
    setEditingUnit(null);
    setIsModalOpen(true);
  };

  const handleEditClick = (unit) => {
    setEditingUnit(unit);
    setIsModalOpen(true);
  };

  const handleDeleteClick = (deleteItemId) => {
    mutation.mutate({ type: "delete", id: deleteItemId });
  };

  const handleSave = (data) => {
    mutation.mutate({
      type: editingUnit ? "update" : "create",
      id: editingUnit?.UnitID,
      payload: data,
    });
  };

  const ArticleGroupGridHeader = [
    {
      field: "id",
      headerName: "#",
      width: 70,
      headerClassName: "super-app-theme--header",
      groupable: false,
      aggregable: false,
    },
    {
      field: "name",
      headerName: "Emri i njesis",
      width: 1000,
      editable: false,
      headerClassName: "super-app-theme--header",
      groupable: false,
      aggregable: false,
    },
    {
      field: "active",
      headerName: "Statusi",
      width: 100,
      editable: false,
      headerClassName: "super-app-theme--header",
      groupable: false,
      aggregable: false,
    },
  ];

  const rows = units.map((item, index) => ({
    id: ++index,
    name: item.UnitName,
    active: item.IsActive ? "Aktiv" : "Jo-Aktiv",
    deleteItemId: item.UnitID,
    rowInfo: item,
  }));

  return (
    <div className="UP__page">

      <CrudPageHeader
        icon={Package}
        title="Njesitë matëse"
        description="Menaxhoni, shtoni, modifikoni dhe fshini njesitë matëse në mënyrë efikase."
        tutorialLabel="Shiko Tutorialin"
        onTutorialClick={() => infoAlert("Tutorial së shpejti!")}
        action={
          <AddAnElementButton
            className="UP__btn-primary"
            text="Njesi e Re"
            icon={<Plus size={16} />}
            onClick={handleAddClick}
          />
        }
        className="UP__header"
      />

      <DataGridWithActions
        columns={ArticleGroupGridHeader}
        rows={rows}
        handleEdit={handleEditClick}
        handleDelete={handleDeleteClick}
        showPayment={false}
        height={500}
      />

      {/* Modal */}
      <UnitModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={handleSave}
        initialData={editingUnit}
      />
    </div>
  );
}
